import { SupportedLanguages, SupportedRegions } from '@rbi-ctg/frontend';
import { SORTED_PROD_SUPPORTED_LOCALES } from 'state/intl/constants';
import { loadLanguage } from 'utils/intl/language';
import { inferLanguageFromUrlParams } from 'utils/intl/language/infer-language-from-url-params';
import { loadRegion } from 'utils/intl/region';
import { inferRegionFromUrlParams } from 'utils/intl/region/infer-region-from-url-params';
import LocalStorage, { StorageKeys } from 'utils/local-storage';

import { getLanguageAndRegionFromLocaleString } from './get-language-and-region-from-locale-string';

export { getLanguageAndRegionFromLocaleString };

export function inferSupportedLocale(
  newLanguage: SupportedLanguages,
  newRegion: SupportedRegions,
  useDefault = false
): string {
  const lowerCaseRegion = (newRegion || '').toLowerCase();
  const regionSupportedLocales = SORTED_PROD_SUPPORTED_LOCALES.filter(locale =>
    locale.toLowerCase().includes(lowerCaseRegion)
  );

  if (useDefault) {
    return regionSupportedLocales[0];
  }

  // Find the first item on the list with the langauge that we care about
  return (
    regionSupportedLocales.find(sortedLocale => sortedLocale.startsWith(`${newLanguage}`)) ||
    regionSupportedLocales[0]
  );
}

export function hydrateInitialLocale(useDefault = false): string {
  const newLocale = inferSupportedLocale(loadLanguage(), loadRegion(), useDefault);

  const [newLocaleLanguage, newLocaleRegion] = getLanguageAndRegionFromLocaleString(newLocale);
  const currentLanguage = LocalStorage.getItem(StorageKeys.LANGUAGE);
  const currentRegion = LocalStorage.getItem(StorageKeys.REGION);

  if (currentLanguage !== newLocaleLanguage || inferLanguageFromUrlParams()) {
    LocalStorage.setItem(StorageKeys.LANGUAGE, newLocaleLanguage);
  }

  if (currentRegion !== newLocaleRegion || inferRegionFromUrlParams()) {
    LocalStorage.setItem(StorageKeys.REGION, newLocaleRegion);
  }

  return newLocale;
}
